import React from 'react';
import { formatDate, formatDateTime, getVoucherExpiryDate } from '../utils/voucherDates';

export default function PublicVoucherCard({ voucher }) {
  const expiresAt = getVoucherExpiryDate(voucher.purchaseDate, voucher.expiresAt);
  const usageHistory = voucher.movements.filter((movement) => movement.type === 'redeem');

  return (
    <div className="bg-white rounded-3xl shadow-2xl p-8 space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-gray-400">Bono</p>
          <h2 className="text-3xl font-bold text-slate-900">{voucher.voucherCode}</h2>
          <p className="text-slate-500 mt-1">Consulta de estado y usos disponibles</p>
        </div>
        <div className="bg-emerald-50 border border-emerald-200 rounded-2xl px-6 py-4 text-center min-w-[180px]">
          <p className="text-xs uppercase tracking-[0.18em] text-emerald-600">Disponible</p>
          <p className="text-4xl font-black text-emerald-700">{voucher.hoursAvailable}h</p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-slate-50 rounded-2xl p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Horas compradas</p>
          <p className="text-2xl font-bold text-slate-900">{voucher.hoursPurchased}h</p>
        </div>
        <div className="bg-slate-50 rounded-2xl p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Horas usadas</p>
          <p className="text-2xl font-bold text-slate-900">{voucher.hoursUsed}h</p>
        </div>
        <div className="bg-slate-50 rounded-2xl p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Vencimiento</p>
          <p className="text-2xl font-bold text-slate-900">{formatDate(expiresAt)}</p>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-3">Usos del bono</h3>
        {usageHistory.length === 0 ? (
          <p className="text-slate-500">Todavía no hay usos registrados.</p>
        ) : (
          <div className="space-y-3">
            {usageHistory.map((movement) => (
              <div key={movement.id} className="flex items-center justify-between rounded-2xl border border-slate-200 px-4 py-3">
                <div>
                  <p className="font-semibold text-slate-900">{movement.hours}h usadas</p>
                  <p className="text-sm text-slate-500">{formatDateTime(movement.performedAt)}</p>
                </div>
                <span className="text-sm font-semibold text-emerald-600">Canjeado</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
